import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "badgeItem", many: "badgeItemsUser"})
export default class Badge {

	@Field()
	public id: ID;

	@Field()
	public title: string;

	@Field()
	public imageUrl: string;

	@Field()
	public url: string;

	// where badge is currently claimable
	@Field()
	public pending: boolean;

	@Field()
	public issuedAt: string;

	@Field()
	public acceptUrl?: string;

	@Field()
	public description?: string;

	@Field()
	public expiresAt?: string;

}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Badge.ts